import { css } from '@emotion/react';
import { type FC } from 'react';
import { useTranslation } from '~/_shared/utils/hooks';
import type { MapListingRowItem } from '~/map/listing/tableData/mapRow/mapRow.component';

const toggleButtonStyle = css({
  background: 'none',
  border: 'none',
  padding: 0,
  color: 'inherit',
});

type MapRowToggleProps = Readonly<{
  item: MapListingRowItem;
  onClick: (mapId: number) => void;
  areSubMapsExpanded: boolean;
  className?: string;
  children?: React.ReactNode;
}>;

export const MapRowToggleComponent: FC<MapRowToggleProps> = (props) => {
  const [t] = useTranslation();

  const snapshotCount = props.item.snapshots.length;
  const baseMapsCount = props.item.layering?.baseMaps.length ?? 0;
  if (!(snapshotCount + baseMapsCount)) {
    return <>{props.children}</>;
  }

  return (
    <button
      className={props.className}
      css={toggleButtonStyle}
      onClick={() => props.onClick(props.item.id)}
      title={t(props.areSubMapsExpanded ? 'mapListing.subItems.collapse' : 'mapListing.subItems.expand')}
    >
      {props.children}
    </button>
  );
};
